import React from 'react'
import styled from 'styled-components'
import { Button } from '../../components/button'
import { Category } from '../../components/category'
import { colors } from '../../colors'
import { PostCard } from '../../components/postCard'
import { SearchInput } from '../../components/input'
// import { NewsPaperFeed } from '../landingpage/components/newspaperfeeds'

const Components = () => {
  return (
    <Container>
        
        <Button filled bgColor={colors.secondary} text={'Submit'} />
        <Category />
        <PostCard />
        {/* <NewsPaperFeed /> */}

        {/* <NewsPaperFeed tags /> */}
        <inputContent>
            <SearchInput />
        </inputContent>

    </Container>
  )
}

const Container = styled.div`
    width: 1080px;
    max-width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    height: 100vh;

`;

const inputContent = styled.div`
    width: 60%;
    background-color: ${colors.primary};
`

export {Components}